<template>
  <v-combobox
    v-model="selectedUsers"
    flat
    :hide-no-data="!search"
    :items="!search ? dropDownList : typeAheadList"
    item-value="name"
    item-text="name"
    :search-input.sync="search"
    :label="label"
    multiple
    small-chips
    height="32"
    :solo="solo"
    class=""
    color="grey lighten-4"
    :background-color="color ? color : 'white'"
    :hide-details="hideDetails"
    :append-icon="hideIcon ? null : 'arrow_drop_down'"
  >
    <template slot="prepend-inner">
      <v-btn icon small v-if="avatarOnly && !selectedUsers.length">
        <v-icon color="grey" class="lighten-2">account_circle</v-icon>
      </v-btn>
    </template>
    <template slot="no-data">
      <v-list-item>
        <span class="subheading">Invite</span>
        <v-chip color="grey lighten-3" label small> {{ search }} </v-chip>
      </v-list-item>
    </template>
    <template slot="selection" slot-scope="{ item, parent, selected }">
      <v-chip color="grey lighten-3" :input-value="selected" small :class="avatarOnly ? 'px-0' : null">
        <span :class="!avatarOnly ? 'pr-2' : null" v-if="item === Object(item)">
          <user-avatar size="10px" :avatarUrl="item.avatar"></user-avatar>
          <template v-if="!avatarOnly">{{ item.name }}</template>
        </span>
        <span class="pr-2" v-else> {{ item }} </span>
        <v-icon v-if="removeable" small @click="parent.selectItem(item)">close</v-icon>
      </v-chip>
    </template>
    <template slot="item" slot-scope="{ index, item }">
      <v-list-item-content v-if="item === Object(item)">
        <v-chip color="grey lighten-4">
          <user-avatar :avatarUrl="item.avatar" class="mr-3"></user-avatar>
          {{ item.name }}
        </v-chip>
      </v-list-item-content>
      <v-list-item-content v-else>
        <v-chip color="grey lighten-4" small label> {{ item }} </v-chip>
      </v-list-item-content>
    </template>
  </v-combobox>
</template>

<script>
import UserAvatar from '@/components/UserAvatar';

export default {
  props: {
    removeable: {
      type: Boolean,
      default: true
    },
    dropDownList: {},
    typeAheadList: {},
    label: {},
    value: {},
    hideDetails: {},
    color: {},
    hideIcon: {},
    solo: {},
    avatarOnly: {}
  },
  components: { UserAvatar },
  data() {
    return {
      search: ''
    };
  },
  computed: {
    selectedUsers: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit('input', v);
      }
    }
  }
};
</script>

<style></style>
